import { Heart, ShoppingCart, Trash2 } from "lucide-react";
import React, { useContext } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { CartContext } from "shared/contexts/Cart/CartContext";
import { IProduto } from "shared/interfaces/IProduto";
import { toggleFavorito } from "shared/services/api/favorito.api";
import { AvaliacaoEstrelas } from "../avaliacaoestrelas/AvaliacaoEstrelas";
import { PrecoFaixa } from "../preco/PrecoFaixa";
import styles from "./Favorito.module.scss";

interface FavoritoProps {
  produto: IProduto;
  onExcluir: (id: string) => void;
}

export const Favorito: React.FC<FavoritoProps> = ({ produto, onExcluir }) => {
  const { addItemCart } = useContext(CartContext);
  const navigate = useNavigate();
  const handleExcluir = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await toggleFavorito(produto.id);
      onExcluir(produto.id);
      toast.success("Removido dos favoritos");
    } catch (error) {
      toast.error("Erro ao remover favorito");
    }
  };
  const imagemPrincipal = produto.gallery?.[0] || "/imagens/default.png";

  return (
    <Link to={`/produto/${produto.id}`} className={styles.link}>
      <div className={styles.card}>
        {/* Imagem */}
        <div className={styles.imgContainer}>
          <img
            src={imagemPrincipal}
            alt={produto.name ?? "Produto"}
            className={styles.imgProduto}
          />
          <div className={styles.containerTrash}>
            <Trash2
              size={22}
              color="white"
              onClick={handleExcluir}
              className={styles.trashIcon}
            />
          </div>
        </div>
        <div className={styles.containerInfo}>
          {/* Nome */}
          <p className={styles.nome}>{produto.name ?? "Produto sem nome"}</p>

          {/* Avaliação */}
          <div className={styles.containerAvaliacoes}>
            <AvaliacaoEstrelas
              rating={produto.avaliacao ?? 0}
              total={produto.totalAvaliacoes ?? 0}
              size={8}
            />
            <p className={styles.avaliados}>(0)</p>
          </div>

          {/* Ações */}
          <div className={styles.containerPrice}>
            {/* Preço */}
            {(produto.priceMin ?? produto.price) !== undefined && (
              <p className={styles.preco}>
                <PrecoFaixa produto={produto} classeSimbolo={styles.cifrao} />
              </p>
            )}
            <div className={styles.actions}>
              <Heart
                size={12}
                fill="red"
                color="red"
                className={styles.favoritoIcon}
              />
              <ShoppingCart
                size={12}
                onClick={(e) => {
                  e.preventDefault();
                  // Com variações, o cliente escolhe a combinação na página.
                  if (produto.hasVariations) {
                    navigate(`/produto/${produto.id}`);
                    return;
                  }
                  addItemCart(produto);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};
